( function( $, document, window ) {
	'use strict';

	$( function() {
		$('.js-card-slider').each(function () {
			const carousel = $(this);
			const sliderEl = $('.swiper', carousel)[0];
			const sliderFull = $(sliderEl).hasClass('swiper--full');
			const navParent = $('.js-carousel-nav', carousel).parent();

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 0,
				slidesPerView: 1,
				effect: 'fade',
				autoHeight: true,
				loop: true,

				navigation: {
					nextEl: $('.js-carousel-nav-next', carousel)[0],
					prevEl: $('.js-carousel-nav-prev', carousel)[0],
				},
			});
		});
	});
} )( jQuery, document, window );
